<ion-header>
  <ion-toolbar>
    <ion-title>
      <span
        *ngIf="subscriptionRadial?.subscription.extra_subscribable || subscriptionRadial?.subscription.reset_subscribable"
      >
        Suscripción
      </span>
      <span
        *ngIf="!subscriptionRadial || (!subscriptionRadial.subscription.extra_subscribable && !subscriptionRadial.subscription.reset_subscribable)"
      >
        Método de pago
      </span>
    </ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/subscription/selection" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="subscriptionRadial" class="summary">
    <div class="ion-padding">
      <h3>Resumen</h3>
      <h4>
        Suscripción:
        <strong *ngIf="subscriptionRadial">{{subscriptionRadial.subscription.fullname}}</strong>
        <br />
        <strong
          *ngIf=" subscriptionRadial && subscriptionRadial.subscription && subscriptionRadial.subscription.zone_name"
        >
          {{subscriptionRadial.subscription.zone_name}}
        </strong>
      </h4>
    </div>
    <div *ngIf="subscriptionRadial">
      <ion-card *ngFor="let item of subscriptionRadial.schedule">
        <ion-row>
          <ion-col>
            <h5>{{item.day}}</h5>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="subscriptionRadial.subscription && ( subscriptionRadial.subscription.type==='complete' || subscriptionRadial.subscription.type==='go')"
        >
          <ion-col>
            <strong><u>LLEGADA</u></strong>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="subscriptionRadial.subscription && ( subscriptionRadial.subscription.type==='complete' || subscriptionRadial.subscription.type==='go')"
        >
          <ion-col>
            <strong>Ruta y parada:</strong>
            <p *ngIf="item.go.stop" hidden>Ruta {{item.go.stop.route_id}}</p>
            <p *ngIf="item.go.stop">{{item.go.stop.name}}</p>
          </ion-col>
          <ion-col size="5" class="ion-text-center">
            <strong>Hora:</strong>
            <p>{{item.go.departure_time}}</p>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="subscriptionRadial.subscription && ( subscriptionRadial.subscription.type==='complete' || subscriptionRadial.subscription.type==='return')"
        >
          <ion-col>
            <strong><u>SALIDA</u></strong>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="subscriptionRadial.subscription && ( subscriptionRadial.subscription.type==='complete' || subscriptionRadial.subscription.type==='return')"
        >
          <ion-col>
            <strong>Ruta y parada:</strong>
            <p *ngIf="item.return.stop" hidden>Ruta {{item.return.stop.route_id}}</p>
            <p *ngIf="item.return.stop">{{item.return.stop.name}}</p>
          </ion-col>
          <ion-col size="5" class="ion-text-center">
            <strong>Hora:</strong>
            <p>{{item.return.departure_time}}</p>
          </ion-col>
        </ion-row>
      </ion-card>
    </div>
  </div>
  <hr style="margin: 20px 0" />
  <ion-card
    (click)="presentAlertConfirm('credit_card_paycode')"
    *ngIf="vendorsStore.isPayCodeActive() && !subscriptionRadial?.subscription.extra_subscribable && !subscriptionRadial?.subscription.reset_subscribable"
  >
    <img src="assets/imgs/creditcard.jpg" />
    <p>PayCode</p>
  </ion-card>
  <ion-card
    *ngIf="vendorsStore.isConektaActive() && !subscriptionRadial?.subscription.extra_subscribable && !subscriptionRadial?.subscription.reset_subscribable"
    (click)="presentAlertConfirm('credit_card')"
  >
    <img src="assets/imgs/creditcard.jpg" />
    <p>Conekta</p>
  </ion-card>
  <ion-card
    *ngIf="!subscriptionRadial?.subscription.extra_subscribable && !subscriptionRadial?.subscription.reset_subscribable"
    (click)="balance && balance >= amount && presentAlertConfirm('wallet')"
    [class.noFunds]="!balance || !amount || balance < amount"
  >
    <ion-icon src="/assets/icon/wallet.svg" color="primary"></ion-icon>
    <p>Pago con wallet</p>
    <p class="price" *ngIf="balance">Balance ${{balance | number}}</p>
  </ion-card>
  <ion-card
    *ngIf="vendorsStore.paypalKey() && amount && !subscriptionRadial?.subscription.extra_subscribable && !subscriptionRadial?.subscription.reset_subscribable"
    class="ion-padding"
  >
    <app-payment-paypal
      [clientId]="vendorsStore.paypalKey()!"
      [amount]="amount"
      (paymentSuccess)="onPayPalSuccess($event)"
      (error)="onPayPalError($event)"
    ></app-payment-paypal>
    <p>PayPal</p>
  </ion-card>
  <ion-card
    (click)="presentAlertConfirm('extra')"
    *ngIf="subscriptionRadial?.subscription.extra_subscribable || subscriptionRadial?.subscription.reset_subscribable"
  >
    <p color="primary">Suscribir</p>
  </ion-card>
</ion-content>

<ion-footer
  *ngIf="amount && subscriptionRadial && (!subscriptionRadial.subscription.extra_subscribable && !subscriptionRadial?.subscription.reset_subscribable)"
>
  <ion-toolbar class="ion-padding">
    <ion-text>A pagar: ${{amount | number}}</ion-text>
  </ion-toolbar>
</ion-footer>
